import { render, staticRenderFns } from "./EleccionTurno.vue?vue&type=template&id=2748f9ad&scoped=true&lang=pug"
import script from "./EleccionTurno.vue?vue&type=script&lang=js"
export * from "./EleccionTurno.vue?vue&type=script&lang=js"
import style0 from "./EleccionTurno.vue?vue&type=style&index=0&id=2748f9ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748f9ad",
  null
  
)

export default component.exports